import { render, staticRenderFns } from "./IconLockClosedOutline.vue?vue&type=template&id=d0cf724a"
import script from "./IconLockClosedOutline.vue?vue&type=script&lang=js"
export * from "./IconLockClosedOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports